import { LeadOutcome } from "#models/questionnaire";
import API from './http';

export const getClientSecretId = async (payload: {
  productId: string;
  priceId: string;
}): Promise<{ clientSecret: string }> => {
  const payloadData = { PurchaseDetails: [{ ...payload }] };
  const response = await API.post(`/api/billing/customer/payment/payment-intent`, payloadData);
  return response.data;
};

export const updateLeadOutcome = async (payload: LeadOutcome) => {
  const { completedQuestionnaireId } = payload;
  const leadPayload = payload.optionalFields;
  const response = await API.put(
    `/api/store/public/lead/completed-questionnaire/${completedQuestionnaireId}/fields`,
    leadPayload
  );
  return response.data;
};
